<template>
  <div class="container-fluid p-4">
    <loading-spinner
      ref="spinner"
      spinnerType="border"
      color="primary"
    ></loading-spinner>
    <div class="row g-4">
      <div class="col-12 col-lg-3">
        <nav
          class="sticky-kit nav-deep nav-deep-light d-lg-block d-md-none d-sm-none d-xs-none"
        >
          <div class="card">
            <div class="card-body p-0 p-md-4">
              <button
                class="clearfix btn btn-toggle btn-sm w-100 text-align-left shadow-md border rounded d-block d-lg-none js-togglified"
                data-bs-target="#nav_questionCategories"
                data-toggle-container-class="d-none d-sm-block bg-white shadow-md border animate-fadein rounded p-3"
                @click="btnCategoryClick"
              >
                <span class="group-icon px-2 py-2 float-start">
                  <i class="fi fi-bars-2" v-if="!isMenueActive"></i>
                  <i class="fi fi-close" v-if="isMenueActive"></i>
                </span>

                <span class="h6 py-2 m-0 float-start">
                  طبقه بندی پرسش‌های متداول
                </span>
                <a
                  class="float-end pointer text-danger-hover"
                  href="#"
                  @click="resetSelectedCategory"
                  ><i class="fi fi-reload text-dark text-danger-hover"></i
                ></a>
              </button>
              <ul
                ref="nav_questionCategories"
                id="nav_questionCategories"
                class="nav flex-column d-lg-block mt-1 mt-lg-0 d-none"
              >
                <li v-if="!isMenueActive">
                  <div
                    class="d-flex align-items-center mb-2 pb-4 border-bottom"
                  >
                    <div class="flex-none border rounded-circle">
                      <svg
                        width="24px"
                        height="24px"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi bi-bounding-box"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M5 2V0H0v5h2v6H0v5h5v-2h6v2h5v-5h-2V5h2V0h-5v2H5zm6 1v2h2v6h-2v2H5v-2H3V5h2V3h6zm1-2h3v3h-3V1zm3 11v3h-3v-3h3zM4 15H1v-3h3v3zM1 4V1h3v3H1z"
                        ></path>
                      </svg>
                    </div>
                    <div class="w-100 px-3">
                      <span class="float-start d-block fw-bold">
                        طبقه بندی پرسش‌های متداول
                      </span>
                      <a
                        class="float-end pointer text-danger-hover"
                        href="#"
                        @click="resetSelectedCategory"
                        ><i class="fi fi-reload text-dark text-danger-hover"></i
                      ></a>
                    </div>
                  </div>
                </li>
                <li
                  class="nav-item"
                  v-for="category in allCategories"
                  :key="category.id"
                  :class="{
                    active: searchQuestionViewModel.categoryID == category.id,
                  }"
                >
                  <a
                    class="nav-link px-0 d-flex align-items-center"
                    href="#"
                    @click="this.categoryItemClick(category.id)"
                  >
                    <i class="fi fi-arrow-end ms-2 small"></i>
                    <span>{{ category.title }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <searchable-input
          mode="single"
          placeHolder="طبقه بندی پرسش های متداول"
          ref="questionAnswerCategoryComboBox"
          :options="allCategoryLables"
          v-model:inputValue="searchQuestionViewModel.categoryID"
          @multiSelectChanged="allCategoryLablesChanged"
          inputThem="purpleThem"
          :canClear="true"
          topTitle=""
          inputTitle=""
          topTitleClass=""
          containerClass="my-1 d-block d-lg-none"
        />
      </div>

      <div class="col-12 col-lg-9">
        <div class="input-group-over d-block mb-1">
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control searchBox"
              placeholder="جستجو در پرسش های متداول..."
              v-model="searchQuestionViewModel.searchInputText"
              @keydown="searchTextInputKeyDown"
            />
          </div>
          <button
            type="submit"
            class="btn smaller"
            @click="getFAQQuestionAnswers"
          >
            <i class="fi fi-search m-0"></i>
          </button>
          <button
            type="submit"
            class="btn smaller ms-5"
            v-if="searchQuestionViewModel.searchInputText"
            @click="clearSearch"
          >
            <i class="fi fi-close m-0"></i>
          </button>
        </div>
        <div class="row">
          <div
            class="col-md-12"
            v-if="searchQuestionViewModel.categoryID != null"
          >
            <!-- <h5 class="p-2 d-lg-block d-md-none d-sm-none d-xs-none">
              <i class="fi fi-search"></i>
              طبقه بندی پرسش های متداول:
              <span class="fw-bold"
                >"{{
                  getCategoryTitle(searchQuestionViewModel.categoryID)
                }}"</span
              >
              <a class="me-2 pointer" href="#" @click="resetSelectedCategory"
                ><i class="fi fi-close text-danger"></i
              ></a>
            </h5> -->
          </div>
          <div class="col-md-12" v-if="searchQuestionViewModel.keyWord != ''">
            <h5 class="p-2">
              <i class="fi fi-task-list ms-2"></i>
              نتایج جستجو برای عبارت:
              <span class="fw-bold"
                >"{{ searchQuestionViewModel.keyWord }}"</span
              >
              <a
                class="me-2 pointer"
                v-if="searchQuestionViewModel.searchInputText"
                @click="clearSearch"
              >
                <i class="fi fi-close m-0 text-danger"></i>
              </a>
            </h5>
          </div>
        </div>

        <div
          class="p-1 fs-5 text-secondary h-75 text-center"
          v-if="searchResult.length == 0"
        >
          <!-- <div class="y-middle">اطلاعاتی جهت نمایش وجود ندارد</div> -->
        </div>

        <div class="row py-3">
          <div
            class="accordion aos-init aos-animate"
            id="accordionBottomBorder"
            data-aos="fade-in"
            data-aos-delay="250"
          >
            <div v-for="item in searchResult" :key="item.id" class="card mb-4">
              <div
                class="card-header border-0 p-0 border bg-transparent"
                id="cleanHeadingBorder5"
              >
                <h4 class="mb-0">
                  <button
                    class="btn bg-gray-200 w-100 btn-lg text-align-start text-decoration-none text-dark collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    :data-bs-target="`#shadowCollapse_${item.id}`"
                    aria-expanded="false"
                    aria-controls="shadowCollapse5"
                  >
                    {{ item.question }}
                    <span class="group-icon float-end">
                      <i class="fi fi-arrow-start-slim"></i>
                      <i class="fi fi-arrow-down-slim"></i>
                    </span>
                  </button>
                </h4>
              </div>

              <div
                :id="`shadowCollapse_${item.id}`"
                class="collapse"
                aria-labelledby="cleanHeadingBorder5"
                data-bs-parent="#accordionBottomBorder"
              >
                <div class="card-body">
                  <p class="justified mt-2" v-html="item.answer"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import LoadingSpinner from '../../components/utility/loadingSpinner/LoadingSpinner.vue';
import SearchableInput from '../../components/form/searchableInput/SearchableInput.vue';

export default {
  components: {
    LoadingSpinner,
    SearchableInput,
  },
  data() {
    return {
      isMenueActive: false,
      allCategories: [],
      allCategoryLables: [],
      searchResult: [],

      searchQuestionViewModel: {
        categoryID: null,
        keyWord: '',
        searchInputText: '',
      },
    };
  },
  methods: {
    btnCategoryClick() {
      'd-none d-sm-block bg-white shadow-md border animate-fadein rounded p-3'
        .split(' ')
        .forEach((f) => {
          this.$refs.nav_questionCategories.classList.toggle(f);
        });
      this.isMenueActive = !this.isMenueActive;
    },
    getCategoryTitle(id) {
      return this.allCategories.find((f) => f.id == id)?.title ?? '';
    },
    async allCategoryLablesChanged(id) {
      let that = this;
      that.searchQuestionViewModel.categoryID = id;
      that.searchQuestionViewModel.searchInputText = '';
      await this.getFAQQuestionAnswers();
    },
    async searchTextInputKeyDown(e) {
      if (e.key == 'Enter') {
        // this.searchQuestionViewModel.categoryID = null;
        await this.getFAQQuestionAnswers();
      }
    },
    async clearSearch() {
      this.searchQuestionViewModel.keyWord = '';
      this.searchQuestionViewModel.searchInputText = '';
      await this.getFAQQuestionAnswers();
    },

    async getAllCategories() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .get('/ST/FAQCategory/GetAllCategories')
        .then((response) => {
          that.allCategories = response.data;
          that.allCategoryLables = response.data.map((m) => {
            return { id: m.id, label: m.title };
          });
          // this.$refs.spinner.hide();
        })
        .catch(() => {
          // this.$refs.notification.show({
          //   type: 'error',
          //   title: `عملیات ویرایش ردیف انتخاب شده با خطا مواجه گردید`,
          // });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    async categoryItemClick(id) {
      let that = this;
      that.searchQuestionViewModel.categoryID = id;
      that.searchQuestionViewModel.searchInputText = '';
      await this.getFAQQuestionAnswers();
    },
    async getFAQQuestionAnswers() {
      let that = this;
      if (that.searchQuestionViewModel.searchInputText) {
        that.searchQuestionViewModel.keyWord =
          that.searchQuestionViewModel.searchInputText;
      } else {
        that.searchQuestionViewModel.keyWord = '';
      }
      this.$refs.spinner.show();
      await axios
        .post(
          '/ST/FAQQuestionAnswer/SearchFAQQuestionAnswers',
          that.searchQuestionViewModel
        )
        .then((response) => {
          that.searchResult = response.data;
        })
        .catch(() => {
          // this.$refs.notification.show({
          //   type: 'error',
          //   title: `عملیات ویرایش ردیف انتخاب شده با خطا مواجه گردید`,
          // });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    getPersianPublishDate(date) {
      /* eslint-disable */
      return new persianDate(new Date(date)).format('LLLLL');
    },
    async moreQuestionAnswerClick() {
      this.searchQuestionViewModel.recordCount += 9;
      await this.getFAQQuestionAnswers();
    },
    async resetSelectedCategory() {
      this.searchQuestionViewModel.categoryID = null;
      await this.getFAQQuestionAnswers();
    },
  },
  async mounted() {
    try {
      this.$refs.spinner.show();
      await this.getAllCategories();
      await this.getFAQQuestionAnswers();
    } finally {
      this.$refs.spinner.hide();
    }
  },
};
</script>
<style scopped></style>
